import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Companion_getInstance2zux61tby3qbv as Companion_getInstance } from './HexFormat.mjs';
import { Companion_instanceovl8he3jiijf as Companion_instance } from '../collections/AbstractList.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../js/charSequenceJs.mjs';
import {
  Char__toInt_impl_vasixd1agw9q2fuvclj as Char__toInt_impl_vasixd,
  toString3o7ifthqydp6e as toString,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
} from '../Char.mjs';
import { equals2ukvbdmtrnsss as equals } from './Char.mjs';
import { substringiqarkczpya5m as substring } from './stringJs.mjs';
import { NumberFormatException3bgsm2s9o4t55 as NumberFormatException } from '../exceptions.mjs';
import { coerceAtMost322komnqp70ag as coerceAtMost } from '../ranges/_Ranges.mjs';
import { longArray288a0fctlmjmj as longArray } from '../js/arrays.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_BYTE_TO_LOWER_CASE_HEX_DIGITS() {
  _init_properties_HexExtensions_kt__wu8rc3();
  return BYTE_TO_LOWER_CASE_HEX_DIGITS;
}
var BYTE_TO_LOWER_CASE_HEX_DIGITS;
var BYTE_TO_UPPER_CASE_HEX_DIGITS;
function get_HEX_DIGITS_TO_DECIMAL() {
  _init_properties_HexExtensions_kt__wu8rc3();
  return HEX_DIGITS_TO_DECIMAL;
}
var HEX_DIGITS_TO_DECIMAL;
var HEX_DIGITS_TO_LONG_DECIMAL;
function hexToInt(_this__u8e3s4, startIndex, endIndex, format) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
  format = format === VOID ? Companion_getInstance().ft_1 : format;
  _init_properties_HexExtensions_kt__wu8rc3();
  return hexToIntImpl(_this__u8e3s4, startIndex, endIndex, format, 8);
}
function hexToIntImpl(_this__u8e3s4, startIndex, endIndex, format, typeHexLength) {
  _init_properties_HexExtensions_kt__wu8rc3();
  Companion_instance.eh(startIndex, endIndex, _this__u8e3s4.length);
  var numberFormat = format.jt_1;
  if (numberFormat.ot_1) {
    checkNumberOfDigits(_this__u8e3s4, startIndex, endIndex, typeHexLength);
    return parseInt(_this__u8e3s4, startIndex, endIndex);
  }
  var prefix = numberFormat.kt_1;
  var suffix = numberFormat.lt_1;
  checkPrefixSuffixNumberOfDigits(_this__u8e3s4, startIndex, endIndex, prefix, suffix, numberFormat.qt_1, typeHexLength);
  return parseInt(_this__u8e3s4, startIndex + prefix.length | 0, endIndex - suffix.length | 0);
}
function checkNumberOfDigits(_this__u8e3s4, startIndex, endIndex, typeHexLength) {
  _init_properties_HexExtensions_kt__wu8rc3();
  var digits = endIndex - startIndex | 0;
  if (digits < 1) {
    throwInvalidNumberOfDigits(_this__u8e3s4, startIndex, endIndex, 'at least', 1);
  } else if (digits > typeHexLength) {
    checkZeroDigits(_this__u8e3s4, startIndex, (startIndex + digits | 0) - typeHexLength | 0);
  }
}
function parseInt(_this__u8e3s4, startIndex, endIndex) {
  _init_properties_HexExtensions_kt__wu8rc3();
  var result = 0;
  var inductionVariable = startIndex;
  if (inductionVariable < endIndex)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = result << 4;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.text.decimalFromHexDigitAt' call
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(_this__u8e3s4, i);
        var code = Char__toInt_impl_vasixd(this_0);
        if ((code >>> 8 | 0) === 0 && get_HEX_DIGITS_TO_DECIMAL()[code] >= 0) {
          tmp$ret$1 = get_HEX_DIGITS_TO_DECIMAL()[code];
          break $l$block;
        }
        throwInvalidDigitAt(_this__u8e3s4, i);
      }
      result = tmp | tmp$ret$1;
    }
     while (inductionVariable < endIndex);
  return result;
}
function checkPrefixSuffixNumberOfDigits(_this__u8e3s4, startIndex, endIndex, prefix, suffix, ignoreCase, typeHexLength) {
  _init_properties_HexExtensions_kt__wu8rc3();
  if (((endIndex - startIndex | 0) - prefix.length | 0) <= suffix.length) {
    throwInvalidPrefixSuffix(_this__u8e3s4, startIndex, endIndex, prefix, suffix);
  }
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.text.checkContainsAt' call
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(prefix) === 0) {
      tmp$ret$1 = startIndex;
      break $l$block;
    }
    var inductionVariable = 0;
    var last = charSequenceLength(prefix) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(charCodeAt(prefix, i), charCodeAt(_this__u8e3s4, startIndex + i | 0), ignoreCase)) {
          throwNotContainedAt(_this__u8e3s4, startIndex, endIndex, prefix, 'prefix');
        }
      }
       while (inductionVariable <= last);
    tmp$ret$1 = startIndex + prefix.length | 0;
  }
  var digitsStartIndex = tmp$ret$1;
  var digitsEndIndex = endIndex - suffix.length | 0;
  $l$block_0: {
    // Inline function 'kotlin.text.checkContainsAt' call
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(suffix) === 0) {
      break $l$block_0;
    }
    var inductionVariable_0 = 0;
    var last_0 = charSequenceLength(suffix) - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (!equals(charCodeAt(suffix, i_0), charCodeAt(_this__u8e3s4, digitsEndIndex + i_0 | 0), ignoreCase)) {
          throwNotContainedAt(_this__u8e3s4, digitsEndIndex, endIndex, suffix, 'suffix');
        }
      }
       while (inductionVariable_0 <= last_0);
    suffix.length;
  }
  checkNumberOfDigits(_this__u8e3s4, digitsStartIndex, digitsEndIndex, typeHexLength);
}
function throwInvalidNumberOfDigits(_this__u8e3s4, startIndex, endIndex, specifier, expected) {
  _init_properties_HexExtensions_kt__wu8rc3();
  var substring_0 = substring(_this__u8e3s4, startIndex, endIndex);
  throw NumberFormatException().ye('Expected ' + specifier + ' ' + expected + ' hexadecimal digits at index ' + startIndex + ', but was "' + substring_0 + '" of length ' + (endIndex - startIndex | 0));
}
function checkZeroDigits(_this__u8e3s4, startIndex, endIndex) {
  _init_properties_HexExtensions_kt__wu8rc3();
  var inductionVariable = startIndex;
  if (inductionVariable < endIndex)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(charCodeAt(_this__u8e3s4, index) === _Char___init__impl__6a9atx(48))) {
        throw NumberFormatException().ye("Expected the hexadecimal digit '0' at index " + index + ", but was '" + toString(charCodeAt(_this__u8e3s4, index)) + "'.\n" + "The result won't fit the type being parsed.");
      }
    }
     while (inductionVariable < endIndex);
}
function throwInvalidPrefixSuffix(_this__u8e3s4, startIndex, endIndex, prefix, suffix) {
  _init_properties_HexExtensions_kt__wu8rc3();
  var substring_0 = substring(_this__u8e3s4, startIndex, endIndex);
  throw NumberFormatException().ye('Expected a hexadecimal number with prefix "' + prefix + '" and suffix "' + suffix + '", but was ' + substring_0);
}
function throwInvalidDigitAt(_this__u8e3s4, index) {
  _init_properties_HexExtensions_kt__wu8rc3();
  throw NumberFormatException().ye('Expected a hexadecimal digit at index ' + index + ', but was ' + toString(charCodeAt(_this__u8e3s4, index)));
}
function throwNotContainedAt(_this__u8e3s4, index, endIndex, part, partName) {
  _init_properties_HexExtensions_kt__wu8rc3();
  var substring_0 = substring(_this__u8e3s4, index, coerceAtMost(index + part.length | 0, endIndex));
  throw NumberFormatException().ye('Expected ' + partName + ' "' + part + '" at index ' + index + ', but was ' + substring_0);
}
var properties_initialized_HexExtensions_kt_h16sbl;
function _init_properties_HexExtensions_kt__wu8rc3() {
  if (!properties_initialized_HexExtensions_kt_h16sbl) {
    properties_initialized_HexExtensions_kt_h16sbl = true;
    var tmp = 0;
    var tmp_0 = new Int32Array(256);
    while (tmp < 256) {
      var tmp_1 = tmp;
      // Inline function 'kotlin.code' call
      var this_0 = charCodeAt('0123456789abcdef', tmp_1 >> 4);
      var tmp_2 = Char__toInt_impl_vasixd(this_0) << 8;
      // Inline function 'kotlin.code' call
      var this_1 = charCodeAt('0123456789abcdef', tmp_1 & 15);
      tmp_0[tmp_1] = tmp_2 | Char__toInt_impl_vasixd(this_1);
      tmp = tmp + 1 | 0;
    }
    BYTE_TO_LOWER_CASE_HEX_DIGITS = tmp_0;
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(256);
    while (tmp_3 < 256) {
      var tmp_5 = tmp_3;
      // Inline function 'kotlin.code' call
      var this_2 = charCodeAt('0123456789ABCDEF', tmp_5 >> 4);
      var tmp_6 = Char__toInt_impl_vasixd(this_2) << 8;
      // Inline function 'kotlin.code' call
      var this_3 = charCodeAt('0123456789ABCDEF', tmp_5 & 15);
      tmp_4[tmp_5] = tmp_6 | Char__toInt_impl_vasixd(this_3);
      tmp_3 = tmp_3 + 1 | 0;
    }
    BYTE_TO_UPPER_CASE_HEX_DIGITS = tmp_4;
    var tmp_7 = 0;
    var tmp_8 = new Int32Array(256);
    while (tmp_7 < 256) {
      tmp_8[tmp_7] = -1;
      tmp_7 = tmp_7 + 1 | 0;
    }
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.text.forEachIndexed' call
    var index = 0;
    var indexedObject = '0123456789abcdef';
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(indexedObject)) {
      var item = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.code' call
      tmp_8[Char__toInt_impl_vasixd(item)] = _unary__edvuaz;
    }
    // Inline function 'kotlin.text.forEachIndexed' call
    var index_0 = 0;
    var indexedObject_0 = '0123456789ABCDEF';
    var inductionVariable_0 = 0;
    while (inductionVariable_0 < charSequenceLength(indexedObject_0)) {
      var item_0 = charSequenceGet(indexedObject_0, inductionVariable_0);
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var _unary__edvuaz_0 = index_0;
      index_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.code' call
      tmp_8[Char__toInt_impl_vasixd(item_0)] = _unary__edvuaz_0;
    }
    HEX_DIGITS_TO_DECIMAL = tmp_8;
    var tmp_9 = 0;
    var tmp_10 = longArray(256);
    while (tmp_9 < 256) {
      tmp_10[tmp_9] = -1n;
      tmp_9 = tmp_9 + 1 | 0;
    }
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.text.forEachIndexed' call
    var index_1 = 0;
    var indexedObject_1 = '0123456789abcdef';
    var inductionVariable_1 = 0;
    while (inductionVariable_1 < charSequenceLength(indexedObject_1)) {
      var item_1 = charSequenceGet(indexedObject_1, inductionVariable_1);
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var _unary__edvuaz_1 = index_1;
      index_1 = _unary__edvuaz_1 + 1 | 0;
      // Inline function 'kotlin.code' call
      tmp_10[Char__toInt_impl_vasixd(item_1)] = fromInt(_unary__edvuaz_1);
    }
    // Inline function 'kotlin.text.forEachIndexed' call
    var index_2 = 0;
    var indexedObject_2 = '0123456789ABCDEF';
    var inductionVariable_2 = 0;
    while (inductionVariable_2 < charSequenceLength(indexedObject_2)) {
      var item_2 = charSequenceGet(indexedObject_2, inductionVariable_2);
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      var _unary__edvuaz_2 = index_2;
      index_2 = _unary__edvuaz_2 + 1 | 0;
      // Inline function 'kotlin.code' call
      tmp_10[Char__toInt_impl_vasixd(item_2)] = fromInt(_unary__edvuaz_2);
    }
    HEX_DIGITS_TO_LONG_DECIMAL = tmp_10;
  }
}
//region block: exports
export {
  get_BYTE_TO_LOWER_CASE_HEX_DIGITS as get_BYTE_TO_LOWER_CASE_HEX_DIGITS2mrc5tv7dfn1l,
  hexToInt as hexToInt2afwk02t24u35,
};
//endregion

//# sourceMappingURL=HexExtensions.mjs.map
